import React from 'react'
import { WidgetGuard } from 'features/types'
import { TopicNotSelectedGuard } from '../../share/guards'
import FilterContradictoryGuard from './FilterContradictoryGuard'

const StoryScopeWidgetSettingGuards: WidgetGuard = ({ widgetId, children }) => (
  <TopicNotSelectedGuard widgetId={widgetId}>
    <FilterContradictoryGuard widgetId={widgetId}>{children}</FilterContradictoryGuard>
  </TopicNotSelectedGuard>
)

export default StoryScopeWidgetSettingGuards
